<template>
    <div class="story-maker-sticker story-maker-sticker-text" :class="{edit : isEditing}" @click="finish">
       
        <!-- <p class="text-finish" @click="()=>finish()">Terminé</p> -->
        <div class="sticker sticker-text"
            :style="{ 
                top: `${$attrs.position.y}%`, 
                left: `${$attrs.position.x}%`,
                transform: isCover || isPreventCover ? `translate(-50%, -50%) scale(${$attrs.transform.scale}) rotate(${$attrs.transform.rotate}deg)` : '',
                textAlign: `${models.align}`,
            }"
        >
            <p
                :contenteditable="isEditing"
                @input="handlerInput"
                @focus="handlerOnFocus"
                @blur="handlerOnBlur"
                ref="textEditable"
                v-html="models.textFormat"
                spellcheck="false"
                class="textarea"
                :class="`${models.font} ${models.align}`"
                :style="{
                    fontSize: `${0.9375 + models.cursor/16 / 10}em`,
                    textAlign: `${models.align}`,
                    color: models.background == 'primary' ? secondaryColor : models.color,
                    backgroundColor: models.background == 'none' ? '' : models.background == 'secondary' ? secondaryColor : models.color,
                    boxShadow: models.background == 'none' || textEmpty ? '' : `
                        ${models.background == 'secondary' ? secondaryColor : models.color} 0.4em 0px 0px 0.28em, 
                        ${models.background == 'secondary' ? secondaryColor : models.color} -0.4em 0px 0px 0.28em, 
                        ${models.background == 'secondary' ? secondaryColor : models.color} 0px 0px 0px 0.28em
                    `,
                    //padding: textEmpty ? '' : `${(15 + models.cursor / 10) * 0.20}px ${(15 + models.cursor / 10) * 0.40}px`,
                    //borderRadius: `1px`,
                    //borderRadius: `${(15 + models.cursor / 10) * 0.28}px`
                }"
            ></p>
        </div>              

        <div class="container-cursor-size">
            <div class="cursor-size">
                <input v-model="models.cursor" type="range" min="0" max="350">
                <svg width="auto" height="auto" viewBox="0 0 80 794" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M40 793L1 1H79L40 793Z" fill="#CBCBCD" stroke="#CBCBCD" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
        
        <div class="container-action">
            <div class="list-option">
                <div v-if="actionSelected == 'font'" class="list-option-text hide-scrollbar" @wheel="handleHorizontalScroll">
                    <div class="texts">
                        <div class="text modern modern-font" :class="{active : models.font == 'modern-font'}" @click="changeFont('modern-font')">Modern</div>
                        <div class="text classic classic-font" :class="{active : models.font == 'classic-font'}" @click="changeFont('classic-font')">Classic</div>
                        <div class="text signature signature-font" :class="{active : models.font == 'signature-font'}" @click="changeFont('signature-font')">Signature</div>
                        <div class="text editor editor-font" :class="{active : models.font == 'editor-font'}" @click="changeFont('editor-font')">Editor</div>
                        <div class="text poster poster-font" :class="{active : models.font == 'poster-font'}" @click="changeFont('poster-font')">Poster</div>
                        <div class="text bubble bubble-font" :class="{active : models.font == 'bubble-font'}" @click="changeFont('bubble-font')">Bubble</div>
                        <div class="text deco deco-font" :class="{active : models.font == 'deco-font'}" @click="changeFont('deco-font')">Deco</div>
                        <div class="text squeeze squeeze-font" :class="{active : models.font == 'squeeze-font'}" @click="changeFont('squeeze-font')">Squeeze</div>
                        <div class="text typewriter typewriter-font" :class="{active : models.font == 'typewriter-font'}" @click="changeFont('typewriter-font')">Typewriter</div>
                        <div class="text strong strong-font" :class="{active : models.font == 'strong-font'}" @click="changeFont('strong-font')">Strong</div>
                        <div class="text meme meme-font" :class="{active : models.font == 'meme-font'}" @click="changeFont('meme-font')">Meme</div>
                        <div class="text elegant elegant-font" :class="{active : models.font == 'elegant-font'}" @click="changeFont('elegant-font')">Elegant</div>
                        <div class="text directional directional-font" :class="{active : models.font == 'directional-font'}" @click="changeFont('directional-font')">Directional</div>
                        <div class="text literature literature-font" :class="{active : models.font == 'literature-font'}" @click="changeFont('literature-font')">Literature</div>
                    </div>
                </div>

                 <div v-else-if="actionSelected == 'color'" class="list-option-color">
                    <div class="pipette">
                        <div class="icon" :style="{backgroundColor: pickerColors.hex}" @click="()=>{ models.color = pickerColors.hex; colorPickerShow = true; showPipette = true}">

                        <div class="picker-color" v-if="colorPickerShow" @mouseleave="colorPickerShow = false" @mousedown="showPipette = false">
                            <div class="icon-pipette" v-if="eyeDropperIsAccess && showPipette" @mousedown.stop @click.stop="startEyeDropper"></div>
                            <chrome-picker :value="pickerColors" @input="updateFromPicker"/>
                        </div>
                        
                    </div></div>
                    <div class="color-carousel">
                        <carousel :perPage="1" :adjustableHeight="true" :centerMode="true" @pageChange="()=>{}" >
                            <Slide v-for="(colors,index) in [['#FFFFFF','#000000','#4397EF','#70C04F','#F6CB5B','#F08C34','#EA4857','#D12D69','#B100C0'],['#EA3323','#ED858E','#F7D0D1','#FADAB4','#F5C281','#D18E47','#99643A','#432324','#1D4A29'],['#262626','#363636','#555555','#737373','#999999','#B2B2B2','#C7C7C7','#DBDBDB','#EFEFEF']]" :key="index">
                                <div v-for="colorHexa in colors" class="color" :style="`background-color:${colorHexa}`" @click="()=>{models.color = colorHexa; pickerColors.hex = colorHexa}"></div>
                            </Slide>
                        </carousel>
                            
                    </div>
                 </div>
            </div>
            <div class="list-action">
                <div class="action font" :class="{active : actionSelected == 'font'}" @click="actionSelected = 'font'">
                    <div class="icon"></div>
                </div>
                <div class="action color" :class="{active : actionSelected == 'color'}" @click="actionSelected = 'color'">
                    <div class="icon"></div>
                </div>
                <div class="action align" :class="`${models.align}`" @click="models.align = {'center':'start','start':'end','end':'center'}[models.align]">
                    <div class="icon"></div>
                </div>
                <div class="action background" :class="`${models.background}`" @click="models.background = {'secondary':'primary','primary':'none','none':'secondary'}[models.background]">
                    <div class="icon"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { EventBus } from '@/event-bus';
import store from '@/store/index.js';
import { Carousel, Slide } from 'vue-carousel';
import { Chrome } from 'vue-color'
import { getLuminanceColor, adjustColorBrightness, hex2rgb, increase_brightness } from '@/utils/Color.js'
import minxinBot from '@/components/mixins/Bots.vue'

export default {

    components: {
        Carousel,
        Slide,
        'chrome-picker': Chrome,
    },

    mixins: [minxinBot],

    props: {
        id: [Number, String],
        isEditing: Boolean,
        text: String,
        font: String,
        fontSize: Number,
        align: String,
        color: String,
        mentions: Object,
        background: String,
        isPreventCover: Boolean,
        isCover: Boolean,
        setCover: Function,
        setCbClick: Function,
    },
    
    data() {
        return {
            actionSelected: 'font',
            models: {
                textFormat: '',
                textDefault: '',
                font: '',
                cursor: 125,
                align: 'center',
                background: 'secondary',
                color: '#000'
            },
            //cursorPosition: null,
            timeoutFinish: null,
            colorPickerShow: false,

            pickerColors: {
				hex: '#000000',
			},
            
            eyeDropperIsAccess : false,
            showPipette : true,
            textEmpty : true,

            cursor : {
                nodeIndex: null,
                startOffset: null,
                endOffset:null,

                previousCursor: {
                    nodeIndex: null,
                    startOffset: null,
                    endOffset:null
                }
            },

            idMentionSelected: null,

            keyAtPressedEvent : {
                flag: false,
                indexAt: null
            },

            isFocused: false
        }
    },

    mounted () {
        if (this.setCbClick) this.setCbClick(this.clickSticker);

        this.eyeDropperIsAccess = window.EyeDropper ? true : false

        this.$nextTick(()=> {
            if(this.isEditing) this.focusAtEnd()
        })

        EventBus.$on('storyMaker-confirmEditingSticker', this.saveCurrentState);
    },
    
    methods: {

        //pour declancher l'edition du text
        clickSticker() {
            console.log("clickSticker")
            if (this.isEditing) return 
            this.setCover(true)

            this.$nextTick(()=> {
                this.$emit('updateSticker',this.id , {
                    isEditing: true
                })   
            })
        },

        //pour gerer le click lors de l'edition du text
        handlerClick() {
            if(this.isEditing) {
                if (!this.isFocused) this.focusAtEnd()
                if (this.keyAtPressedEvent.flag) {
                    this.closeSelectMention()
                }
            } 
        },
        saveCurrentState() {
            if (!this.isEditing) return;
            if (this.$refs['textEditable'] && this.$refs['textEditable'].innerText.length) {
                this.$emit('updateSticker', this.id, {
                    isEditing: false,
                    data: {
                        ...this.$attrs.data,
                        text: this.$refs['textEditable'].innerHTML,
                        font: this.models.font,
                        align: this.models.align,
                        color: this.models.color,
                        background: this.models.background,
                        fontSize: 15 + parseInt(this.models.cursor) / 10
                    },
                });
            } else {
                this.$emit('deleteSticker', this.id);
            }
            if (this.timeoutFinish) clearTimeout(this.timeoutFinish);
            this.timeoutFinish = setTimeout(() => { this.setCover(false); }, 200);
        },

        finish(event) {
            if (this.isCover && event.target.classList.contains('story-maker-sticker') || event.target.classList.contains('text-finish')) {
                this.saveCurrentState();
            }
        },
        updateFromPicker(value) {
            this.pickerColors = {
                hex: value.hex
            }
            this.models.color = value.hex
        },

        startEyeDropper() {
            if (!window.EyeDropper) return
            this.colorPickerShow = false
            const eyeDropper = new EyeDropper();

            eyeDropper.open().then((result) => {
                this.models.color = result.sRGBHex
                this.pickerColors = {
                    hex: result.sRGBHex
                }
            }).catch((e) => {
            });
        },

        changeFont(name) {
            this.models.font = name
            this.focusAtEnd()
            
        },
        
        focusAtEnd() {

            try {
                const element = this.$refs[`textEditable`]

                const range = document.createRange();
                const selection = window.getSelection();

                range.selectNodeContents(element);
                range.collapse(false);

                selection.removeAllRanges();
                selection.addRange(range);

                // Donnez le focus à l'élément
                element.focus();
            } catch (error) {
                
            }
           
        },
        
        /////// INPUT EVENT ///////
        getTextarea() {
            return this.$refs[`textEditable`]
        },

        handlerInput(e = null, innerHTML = '') {
            

            //console.log('handlerInput')
            if (e) innerHTML = e.target.innerHTML
            this.updateCursorPosition()

            const regex = /(<[^>]+>)|([^<]+)/g;
            let result = '';
            let match;
            
            // Parcours du contenu avec la regex
            while ((match = regex.exec(innerHTML)) !== null) {
                if (match[1]) {
                    // Si c'est une balise HTML, on la laisse telle quelle
                    result += match[1];
                } else if (match[2]) {
                    // Si c'est du texte normal
                    result += match[2] //.replace(/(\s|\u00A0)/g, '&nbsp;');
                }
            }   

            this.models.textFormat = result //(e ? e.target.innerHTML : innerHTML)
            //console.log('handlerInput result',result)
            this.$nextTick(() => {
                this.restoreCursorPosition()
                this.setTextareaContentValue(result, e ? e : undefined)
            });
        },

        handlerOnFocus(e) {
            this.isFocused = true;
        },
        
        handlerOnBlur(e) {
            // Supprime les `<br>` en fin de chaîne
            this.models.textFormat = this.models.textFormat.replace(/(<br\s*\/?>)+$/g, '');
            this.setTextareaContentValue(this.models.textFormat, e)
            this.isFocused = false;
        },

        updateCursorPosition() {
           
           const selection = window.getSelection();

           //console.log("updateCursorPosition selection", selection.rangeCount)
           if (selection.rangeCount > 0) {

               try{
                   const range = selection.getRangeAt(0);
                   let startContainer = range.startContainer;
                   let nodeIndex = -1
                   //console.log("updateCursorPosition startContainer", startContainer, startContainer instanceof HTMLElement)
                   if (startContainer instanceof Text) {
                       const parentNode = startContainer.parentNode.closest('.textarea');
                       while (startContainer.parentNode !== parentNode) {
                           startContainer = startContainer.parentNode;
                       }
                       nodeIndex = Array.from(parentNode.childNodes).indexOf(startContainer);
                   }

                   //console.log("updateCursorPosition range", range)

               
                   if (this.cursor.startOffset !== range.startOffset || this.cursor.nodeIndex !== nodeIndex) {
                       this.cursor = {
                           nodeIndex: nodeIndex,
                           startOffset: range.startOffset,
                           endOffset: range.endOffset,

                           previousCursor: {
                               nodeIndex: this.cursor.nodeIndex,
                               startOffset: this.cursor.startOffset,
                               endOffset: this.cursor.endOffset
                           }
                       };
                   }
               } catch (error) {
                   this.cursor = {
                       nodeIndex: this.cursor.nodeIndex -1,
                       startOffset: 0,
                       endOffset: 0,

                       previousCursor: {
                           nodeIndex: this.cursor.nodeIndex,
                           startOffset: this.cursor.startOffset,
                           endOffset: this.cursor.endOffset
                       }
                   };
               }
               
           }

           //console.log("updateCursorPosition",this.cursor.nodeIndex,this.cursor.startOffset,this.cursor.endOffset)
        },
       
        restoreCursorPosition(restorePreviousCursor = false) {
           //console.log("---------------------------- RestoreCursorPosition Start ----------------------------")
           
           this.getTextarea().focus();

           if (restorePreviousCursor && (!this.cursor.previousCursor || !this.cursor.previousCursor.startOffset)) return;
           if (!restorePreviousCursor && (!this.cursor.startOffset)) return;


           const cursor = restorePreviousCursor ? this.cursor.previousCursor : this.cursor
          
           let node = cursor.nodeIndex >= 0 ? this.getTextarea().childNodes[cursor.nodeIndex] : this.getTextarea()

           if (cursor.nodeIndex >= 0) {
               while (node.childNodes && node.childNodes[0]) {
                   node = node.childNodes[0]
               }
           }
               
           const selection = window.getSelection();
           selection.removeAllRanges();

           const range = document.createRange();

           range.setStart(node, cursor.startOffset);
      
           range.collapse(true);
           selection.addRange(range);
           

            //console.log("---------------------------- RestoreCursorPosition End  ----------------------------")
        },

        setTextareaContentValue(innerHTML,e) {

            function escapeSpecialChars(str) {
                // Remplacer les caractères échappés par leurs équivalents littéraux
                return str
                .replace(/\\/g, '\\\\')   // Backslash '\\'
                .replace(/\n/g, '\\n')     // Newline '\n'
                .replace(/\t/g, '\\t')     // Tab '\t'
                .replace(/\r/g, '\\r')     // Carriage return '\r'
                .replace(/\f/g, '\\f')     // Form feed '\f'
                .replace(/\v/g, '\\v')    // Vertical tab '\v'
                .replace(/ /g, '&nbsp;')  // Space ' ' -> '&nbsp;'
                .replaceAll(" ", '&nbsp;')
                .replace(/\u00A0/g, "&nbsp;");
            }

            const div = document.createElement('div');
            div.innerHTML = innerHTML.replace(/<br>/g, '\n');

            div.querySelectorAll('.tag-mention').forEach(element => {
                element.innerHTML = `@${element.getAttribute("idmention")}`
            });

            let innerText = escapeSpecialChars(div.innerText)

            //detecter le debut d'une mention
            if (e && e.data && e.data == '@') {
                const currentValue = this.models.textDefault
                const newValue = innerText
                const position = newValue.split('').findIndex((char, index) => (currentValue[index] !== char));
                
                let startText = newValue.slice(0,position)
                let endText = newValue.slice(position+1)

                console.log('position',position, startText, endText)

                this.idMentionSelected = (new Date).getTime()


                const newMention = {
                    textDefault : '',
                    mention : {}
                }

                this.$emit('updateSticker',this.id , {
                    data : {
                        ...this.$attrs.data,
                        mentions : {
                            ...this.mentions,
                            [this.idMentionSelected] : newMention
                        }
                    },
                })

                this.keyAtPressedEvent = {
                    flag: true,
                    indexAt: position
                }

                this.$nextTick(() => {
                    EventBus.$on('eventSearchFromSelectMention', this.searchMention);
                    EventBus.$on('eventClickSelectMention', this.addMention);
                    EventBus.$on('eventCloseSelectMention', this.closeSelectMention);
         
                    EventBus.$emit("postCreatorAddMode", "addMentionMode",{ 
                        mention : {
                            ...newMention,
                        },
                        idMention : this.idMentionSelected
                    });

                })
            }
            this.textEmpty = e.target.innerText.length == 0  
            this.models.textDefault = innerText
        },

        updateHtmlTextarea() {
            //important
            //quand this.getTextareaRef().textareaValue change le composant executera setTextareaContentValue
          
            let newValue = this.models.textDefault.replace(/@(\d{13})/g, (match, id) => {
                const mention = this.mentions[id];

                if (mention && mention.mention.instagram) {
                    return `<span class="tag-mention no-select" idmention="${id}" contenteditable="false" spellcheck="false">@${mention.mention.instagram.id.trim()}</span>`
                }
                if (mention && mention.mention.facebook) {
                    return `<span class="tag-mention no-select" idmention="${id}" contenteditable="false" spellcheck="false">@${mention.mention.facebook.name.trim()}</span>`
                }
                return match;
            }).replaceAll('&nbsp;'," ") //.replace(/\\n/g, '<br>')

            //replaceAll('&nbsp;'," ") pour break-word
            
            if (this.getTextarea().innerHTML !== newValue) {
                
                this.$set(this.models, 'textFormat', newValue);

                // if (focus) {
                //     this.$nextTick(() => {
                //         this.restoreCursorPosition(restorePreviousCursor)
                //     })
                // }
            }
        },

        async searchMention(value, network, idEvent, idMention) {
            if (!this.idMentionSelected || idMention !== this.idMentionSelected) return
            if (network !== 'instagram') return


            let isUrl = false
            let page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created) || this.pagesSelected.find(p => p.network == 'instagram' && p.bot_status)

            let result = []
            if (page && value) {
                result = (await this.getMentionsByApi(page.id, value, isUrl)).mentions
            }
            EventBus.$emit("resultSearchFromSelectMention", result, idEvent)
        },

        addMention(network, person, idMention) {
            console.log("addMention")
            EventBus.$emit("postCreatorRemoveMode");
            EventBus.$off('eventClickSelectMention', this.addMention);
            EventBus.$off('eventSearchFromSelectMention', this.searchMention);
            EventBus.$off('eventCloseSelectMention', this.closeSelectMention);

            if (!this.idMentionSelected || 
                this.idMentionSelected !== idMention || 
                !this.mentions[this.idMentionSelected] ||
                network !== 'instagram'
            ) return
            
            if (this.keyAtPressedEvent.flag) {

                if (person) {
                    this.mentions[this.idMentionSelected]

                    const mention = {
                        mention : {
                            'instagram' : person
                        },
                        textDefault : ''
                    }

                    this.$emit('updateSticker',this.id , {
                        data : {
                            ...this.$attrs.data,
                            mentions : {
                                ...this.mentions,
                                [this.idMentionSelected] : mention
                            }
                        },
                    })
                    

                    const position = this.keyAtPressedEvent.indexAt
                    let startText = this.models.textDefault.slice(0,position)
                    let endText = this.models.textDefault.slice(position+1)
                    this.models.textDefault = startText + `@${this.idMentionSelected}` + (endText.replaceAll('\n','').replaceAll('\\n','').length ? endText : '&nbsp;'+endText);
                    this.$nextTick(() => {
                        this.updateHtmlTextarea()
                    })
                }
               
               
              
                this.$set(this.keyAtPressedEvent, 'flag', false)
                
            }
         
        },

        closeSelectMention() {
            EventBus.$off('eventClickSelectMention', this.addMention);
            EventBus.$off('eventSearchFromSelectMention', this.searchMention);
            EventBus.$off('eventCloseSelectMention', this.closeSelectMention);
            this.$set(this.keyAtPressedEvent, 'flag', false)
            this.idMentionSelected = null
            EventBus.$emit("postCreatorRemoveMode");
        },

        handleHorizontalScroll(event) {
            if (event.deltaX == 0) {
                event.preventDefault();
                const scrollContainer = event.currentTarget;
                scrollContainer.scrollLeft += event.deltaY;
            }
        }
                   

    },

    computed: {
        secondaryColor() {
            const rbgColorObject = hex2rgb(this.models.color)

            if (rbgColorObject.r == 255 && rbgColorObject.g == 255 && rbgColorObject.b == 255) return '#000000'
            if (rbgColorObject.r == 0 && rbgColorObject.g == 0 && rbgColorObject.b == 0) return '#FFFFFF'

            console.log('rbgColorObject',rbgColorObject, this.models.color)
            return getLuminanceColor(...Object.values(rbgColorObject)) > 0.78 ? 
                increase_brightness(...adjustColorBrightness(...Object.values(rbgColorObject),0.1),10)
                : increase_brightness(...Object.values(rbgColorObject), 80)
        },

        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },
        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
        },
    },

    watch: {
        text: {
            handler(newValue) {
                this.models.textDefault = newValue
                if (newValue) this.textEmpty = false
                this.$nextTick(() => {
                    this.updateHtmlTextarea()
                })
            },
            immediate: true
        },
        font: {
            handler(newValue) {
                this.models.font = newValue
            },
            immediate: true
        },
        align: {
            handler(newValue) {
                this.models.align = newValue
            },
            immediate: true
        },
        color: {
            handler(newValue) {
                this.models.color = newValue
            },
            immediate: true
        },
        background: {
            handler(newValue) {
                this.models.background = newValue
            },
            immediate: true
        },
        fontSize: {
            handler(newValue) {
                this.models.cursor = (newValue - 15) * 10
            },
            immediate: true
        },
        isEditing: {
            handler(newValue) {
       
                if(newValue) {
                    this.focusAtEnd()

                    if (!this.isPreventCover && !this.isCover) {
                        this.isEditing = false
                        this.clickSticker()
                    }
                }else{
                    EventBus.$off('eventClickSelectMention', this.addMention);
                    EventBus.$off('eventSearchFromSelectMention', this.searchMention);
                    EventBus.$off('eventCloseSelectMention', this.closeSelectMention);
                }

                
            },
            immediate: true
        },
    },

    beforeDestroy () {
        EventBus.$off('eventSearchFromSelectMention', this.searchMention);
        EventBus.$off('eventClickSelectMention', this.addMention);
        EventBus.$off('eventCloseSelectMention', this.closeSelectMention);
        EventBus.$off('storyMaker-confirmEditingSticker', this.saveCurrentState);
    },

    
}
</script>
